<div *ngIf="!tiles" class="flex-list-item">
  <div
    class="filebrowser-preview-icon"
    [ngClass]="{
      'filebrowser-preview-icon-image': getType(item.data.title) === 'image'
    }"
  >
    <div *ngIf="item.type == 'filefolders'">
      <i class="far fa-folder"></i>
    </div>
    <div *ngIf="item.type == 'files'">
      <div [ngSwitch]="getType(item.data.title)">
        <div *ngSwitchCase="'image'" class="file-image-holder">
          <img
            *ngIf="!hasError"
            (error)="this.hasError = true"
            [hidden]="!item.loaded && !hasMountedImage"
            (load)="item.loaded = true; hasMountedImage = true"
            [src]="'/' + item.type + '/' + item.id | safe"
            alt="Preview for {{ item.data.title }}"
          />
          <app-loading-dots
            *ngIf="!item.loaded && !hasMountedImage &&!hasError"
            size="5px"
          ></app-loading-dots>
        </div>
        <div *ngSwitchCase="'zip'">
          <i class="far fa-file-archive"></i>
        </div>
        <div *ngSwitchCase="'pdf'">
          <i class="far fa-file-pdf"></i>
        </div>
        <div *ngSwitchCase="'doc'">
          <i class="far fa-file-alt"></i>
        </div>
        <div *ngSwitchDefault>
          <i class="far fa-file"></i>
        </div>
      </div>

    </div>
  </div>
  <div class="file-content-name">
    <div *ngIf="item.type == 'files'">
      <div *ngIf="download_url">
        <iframe style="display: none" [src]="download_url | safe"></iframe>
      </div>
      <span *ngIf="item && (item.text || item.data)">{{
        item.text || item.data.title
      }}</span>
      <i
        *ngIf="false && !item.data.canvas_id && !item.data.blackboard_id"
        class="fas fa-exclamation-triangle"
        [title]="'file_lms_not_available'| translation"
      ></i>
    </div>
    <div *ngIf="item.type == 'filefolders'">
      <a (click)="navigate(item)">{{ item.data.title }}</a>
    </div>
  </div>
  <div class="file-content-size">
    <span *ngIf="item.type == 'files'">{{ item.data.size | filesize }}</span>
  </div>
  <p-button
    *ngIf="item.type == 'files'"
    class="action-button"
    variant="text"
    severity="contrast"
    [pTooltip]="'view'| translation"
    (click)="
      openFile(
        $event,
        '/files/' + (item.id || item.file),
        item.text || item.data.title
      )
    "
  >
    <span><i class="fas fa-eye"></i></span>
  </p-button>

  <p-button
    *ngIf="item.type == 'files'"
    variant="text"
    severity="contrast"
    class="action-button"
    [pTooltip]="'download'| translation"
    (click)="zipFolder($event, item)"

    aria-label="Download File {{ item?.text || item?.data?.title || '' }}"
  >
  <i class="fa-light fa-file-arrow-down"></i>
  </p-button>


  <p-button
    *ngIf="item.type == 'filefolders'"
    variant="text"
    severity="contrast"
    class="action-button"
    [pTooltip]="'zip'| translation"
    (click)="zipFolder($event, item)"
    aria-label="Zip Folder {{ item?.text || item?.data?.title || '' }}"
  >
    <i class="fas fa-file-archive"></i>
  </p-button>

  <p-button
    class="action-button"
    variant="text"
    severity="contrast"
    [pTooltip]="'settings'| translation"
    (click)="openSettings($event, item)"
    *ngIf="!isDisabled"
  >
    <span><i class="fas fa-pencil-alt"></i></span>
  </p-button>

  <p-button
    class="action-button"
    variant="text"
    severity="contrast"
    [pTooltip]="'move'| translation"
    (click)="openMove($event, item)"
    *ngIf="!isDisabled"

  >
    <span><i class="fas fa-arrows-alt"></i></span>
  </p-button>
  <p-button
    class="action-button"
    variant="text"
    severity="contrast"
    [pTooltip]="'delete'| translation"

    (click)="toDelete($event, item)"
    *ngIf="!isDisabled"
  >
    <span><i class="fat fa-trash-alt"></i></span>
  </p-button>
</div>


<div
  *ngIf="tiles"
  class="file-tile-item"
  [pTooltip]="item.text || item.data.title"
  [class.fileBorder]="getType(item.data.title) != 'image'"
>
  <div *ngIf="item.type == 'filefolders'" class="file-preview">
    <i class="fas fa-folder"></i>
  </div>
  <div
    *ngIf="item.type == 'files' && getType(item.data.title) == 'image'"
    class="file-image-holder"
  >
    <img
      *ngIf="!hasError;else error"
      [hidden]="!item.loaded && !hasMountedImage"
      (error)="this.hasError = true"
      (load)="item.loaded = true; hasMountedImage = true"
      [src]="'/' + item.type + '/' + item.id | safe"
      alt="Preview for {{ item.data.title }}"
    />
    <ng-template #error>
      <div class="file-display-img-error-container">
      <i style="font-size: 32px;" #error class="fas fa-exclamation"></i>
      <label>Error Getting Image</label>
    </div>
    </ng-template>
   
    <div class="file-preview">
      <app-loading-dots
        *ngIf="!item.loaded && !hasMountedImage&&!hasError"
        size="5px"
      ></app-loading-dots>
    </div>
  </div>
  <div *ngIf="item.type == 'files'">
    <div [ngSwitch]="getType(item.data.title)">
      <div *ngSwitchCase="'image'"></div>
      <div *ngSwitchCase="'zip'" class="file-preview">
        <i class="far fa-file-archive"></i>
      </div>
      <div *ngSwitchCase="'pdf'" class="file-preview">
        <i class="far fa-file-pdf"></i>
      </div>
      <div *ngSwitchCase="'doc'" class="file-preview">
        <i class="far fa-file-alt"></i>
      </div>
      <div *ngSwitchDefault class="file-preview">
        <i class="far fa-file"></i>
      </div>
    </div>
  </div>
  <div class="file-preview-button">
    <button
      *ngIf="item.type == 'filefolders'"
      [pTooltip]="'zip'| translation"
      pButton
      size="small"
      severity="contrast"
      (click)="zipFolder($event, item)"
      aria-label="Zip Folder {{ item.text || item.data.title }}"
    >
      <i class="fas fa-file-archive"></i>
    </button>
    <button
      *ngIf="item.type == 'files'"
      [pTooltip]="'view'| translation"
      pButton
      size="small"
      severity="contrast"
      (click)="

        openFile(
          $event,
          '/files/' + (item.id || item.file),
          item.text || item.data.title
        )
      "
      aria-label="Open preview {{ item.text || item.data.title }}"
    >
      <i class="fas fa-eye"></i>
    </button>
    <button
      *ngIf="item.type == 'files'"
      [pTooltip]="'download'| translation"
      pButton
      size="small"
      severity="contrast"
      (click)="zipFolder($event, item)"
      aria-label="Download File {{ item.text || item.data.title }}"

    >
    <i class="fa-light fa-file-arrow-down"></i>
      </button>

    <button
      pButton
      severity="contrast"
      size="small"
      [pTooltip]="'settings'| translation"
      (click)="openSettings($event, item)"
      *ngIf="!isDisabled"

    >
      <span><i class="fas fa-pencil-alt"></i></span>
    </button>
    <button
      pButton
      severity="contrast"
      size="small"
      [pTooltip]="'move'| translation"
      (click)="openMove($event, item)"
      *ngIf="!isDisabled"

    >
      <span><i class="fas fa-arrows-alt"></i></span>
    </button>
    <button
      pButton
      size="small"
      severity="contrast"
      [pTooltip]="'delete'| translation"
      (click)="toDelete($event, item)"
      *ngIf="!isDisabled"

    >
      <span><i class="fat fa-trash-alt"></i></span>
    </button>
  </div>
  <div class="file-tile-label">
    <span
      *ngIf="
        item && (item.text || item.data) && getType(item.data.title) != 'image'
      "
      >{{ item.text || item.data.title }}</span
    >
  </div>
</div>
